export default (values) => {

  const errors = {};

  if (!values.folder) errors.folder = true;

  return errors;
  
}